import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DireccionesService } from "./services/direcciones.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { Direccion, Direcciones } from "../../../entities/Direcciones";

@Component({
  selector: "app-direcciones",
  templateUrl: "./direcciones.component.html",
  styleUrls: ["./direcciones.component.scss"],
})
export class DireccionesComponent implements OnInit {
  public listaDireccion: Direccion[] = [];
  public direccionesForm: FormGroup;
  public id: any;
  public title: string = "Dirección";
  listMensajes: any[];
  public listColonias: Array<string> = [];

  constructor(
    private route: Router,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private direccionesService: DireccionesService,
    private activatedRoute: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.activatedRoute.params.subscribe((params) => {
      this.id = params["id"];
      if (this.id) {
        this.title = "Actualizar Dirección";
        this.obtenerDirecciones(this.id);
        //this.licenciasEditarImagenes();
      }
    });
    this.direccionesService
      .obtenerMensajes()
      .subscribe((result: Direcciones[]) => {
        if (!this.id) {
          if (result.length === 0) {
            this.direccionesForm.patchValue({
              esPredeterminada: true,
            });
          } else {
            this.direccionesForm.patchValue({
              esPredeterminada: false,
            });
          };
        };
      });
  }

  getCP(event: any) {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    input.value = soloNumeros; // Actualiza el valor del input solo con números

    const CP = soloNumeros;

    this.direccionesForm.patchValue({
      colonia: null
    });

    if (CP.length === 5) {
      this.direccionesService.getDirectionCp(CP).subscribe((response: any) => {
        if (!response) {
          this.toastService.error("Código postal incorrecto");
          this.direccionesForm.get("colonia").disable();
          this.direccionesForm.patchValue({
            municipio: "",
            estado: "",
            codigoPostal: "",
            colonia: "",
          });
          this.listColonias = [];
          window.scrollTo({
            top: 0,
            behavior: "smooth", // Para un desplazamiento suave
          });
        } else {
          this.listColonias = [];
          this.listColonias = response.codigo_postal.colonias;
          if (this.listColonias.length === 1) {
            this.direccionesForm.patchValue({
              colonia: this.listColonias[0],
            });
          } else {
            this.listColonias = [""];
            response.codigo_postal.colonias.forEach((col) => {
              this.listColonias.push(col);
            });
          }
          this.direccionesForm.get("colonia").enable();
          this.direccionesForm.patchValue({
            municipio: response.codigo_postal.municipio,
            estado: response.codigo_postal.estado,
          });
        }
      });
    }
  }



  // getCP(event: any) {
  //   const CP = event.target.value;
  //   this.direccionesForm.patchValue({
  //     colonia: null
  //   });
  //   if (CP.length === 5) {
  //     this.direccionesService.getDirectionCp(CP).subscribe((response: any) => {
  //       if (!response) {
  //         this.toastService.error("Código postal incorrecto");
  //         this.direccionesForm.get("colonia").disable();
  //         this.direccionesForm.patchValue({
  //           municipio: "",
  //           estado: "",
  //           codigoPostal: "",
  //           colonia: "",
  //         });
  //         this.listColonias = [];
  //         window.scrollTo({
  //           top: 0,
  //           behavior: "smooth", // Para un desplazamiento suave
  //         });
  //       } else {
  //         this.listColonias = [];
  //         this.listColonias = response.codigo_postal.colonias;
  //         if (this.listColonias.length === 1 ) {
  //           this.direccionesForm.patchValue({
  //             colonia: this.listColonias[0],
  //           });
  //         } else {
  //           this.listColonias = [""];
  //           response.codigo_postal.colonias.forEach((col) => {
  //             this.listColonias.push(col);
  //           });
  //         };
  //         this.direccionesForm.get("colonia").enable();
  //         this.direccionesForm.patchValue({
  //           municipio: response.codigo_postal.municipio,
  //           estado: response.codigo_postal.estado,
  //         });
  //       }
  //     });
  //   }
  // }

  obtenerData() {
    this.direccionesService.obtenerMensajes().subscribe((result) => {
      this.listMensajes = result;
    });
  }

  cancelar() {
    this.route.navigateByUrl("/pages/direcciones");
  }

  obtenerDirecciones(id) {
    this.direccionesService.obtenerDireccion(id).subscribe(
      (result: Direcciones) => {
        this.direccionesForm.patchValue({
          id: id,
          noExterior: result.noExterior,
          calle: result.calle,
          calleEsquina: result.calleEsquina,
          codigoPostal: result.codigoPostal,
          colonia: result.colonia,
          referencia: result.referencia,
          nombreRecibe: result.nombreRecibe,
          telefono: result.telefono,
          esPredeterminada: result.esPredeterminada,
          estado: result.estado,
          municipio: result.municipio,
          noInterior: result.noInterior,
        });
        this.direccionesService
          .getDirectionCp(this.direccionesForm.get("codigoPostal").value)
          .subscribe((response) => {
            this.direccionesForm.get("colonia").enable();
            this.listColonias = response.codigo_postal.colonias;
          });
      },
      (err) => {
        this.toastService.error("Error al obtener la dirección");
      }
    );
  }

  initForm() {
    this.direccionesForm = this.fb.group({
      id: [],
      estado: [{ value: "", disabled: true }, [Validators.required]],
      municipio: [{ value: "", disabled: true }, [Validators.required]],
      noInterior: [""],
      noExterior: ["", [Validators.required]],
      calle: ["", [Validators.required]],
      calleEsquina: ["", [Validators.required]],
      codigoPostal: ["", [Validators.required]],
      colonia: [{ value: "", disabled: true }, [Validators.required]],
      referencia: ["", [Validators.required]],
      nombreRecibe: ["", [Validators.required]],
      telefono: ["", [Validators.required]],
      esPredeterminada: [false],
    });
  }

  get getListaDirecciones() {
    return this.direccionesForm.get("listaDirecciones") as FormArray;
  }

  changeValue(checked) {
    if (checked) {
      this.direccionesForm.patchValue({
        esPredeterminada: true,
      });
    } else {
      this.direccionesForm.patchValue({
        esPredeterminada: false,
      });
    }
  }

  checkedBox() {
    let checked = false;
    let data = this.direccionesForm.get("esPredeterminada").value;

    if (data == true) {
      checked = true;
    }
    return checked;
  }

  submit() {
    this.direccionesForm.get("municipio").enable();
    this.direccionesForm.get("colonia").enable();
    this.direccionesForm.get("estado").enable();

    window.scrollTo({
      top: 0,
      behavior: "smooth", // Para un desplazamiento suave
    });
    if (this.direccionesForm.invalid) {
      this.direccionesForm.get("municipio").disable();
      this.direccionesForm.get("colonia").disable();
      this.direccionesForm.get("estado").disable();
      this.direccionesForm.markAllAsTouched();
      this.toastr.error("Debes completar todos los campos");
    } else {
      if (this.id) {
        this.actualizarDireccion();
      } else {
        this.agregarDireccion();
      }
    }
  }

  agregarDireccion() {
    this.direccionesService
      .agregarDireccion(this.direccionesForm.value)
      .subscribe(
        (response) => {
          this.cancelar();
          Swal.fire({
            title: "¡Operación exitosa!",
            text: `¡Se ha agregado de manera exitosa su dirección!`,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        },
        (err) => {
          this.direccionesForm.reset();
          Swal.fire({
            title: "¡Ops!",
            text: `¡Error al agregar la dirección!`,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        }
      );
  }

  actualizarDireccion() {
    this.direccionesService
      .actualizarDireccion(this.direccionesForm.value)
      .subscribe(
        (success) => {
          this.cancelar();
          Swal.fire({
            title: "¡Operación exitosa!",
            html: `¡Se ha modificado de manera exitosa su dirección!`,
            icon: "success",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        },
        (error) => {
          this.direccionesForm.reset();
          Swal.fire({
            title: "¡Ops!",
            text: `¡Error al intentar actualizar su dirección!`,
            icon: "warning",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Confirmar",
          });
        }
      );
    // },10000)
  }

  soloNumeros(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloNumeros = input.value.replace(/[^0-9]/g, "");
    this.direccionesForm.patchValue({ telefono: soloNumeros });
  }

  soloLetrasNumerosInt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9\s]/g, "");
    this.direccionesForm.patchValue({ noInterior: soloLetrasNumeros });
  }

  soloLetrasNumerosExt(event: any): void {
    const input = event.target as HTMLInputElement;
    const soloLetrasNumeros = input.value.replace(/[^a-zA-Z0-9]/g, "");
    this.direccionesForm.patchValue({ noExterior: soloLetrasNumeros });
  }
}
